import dayjs from "dayjs";
//import Link from "next/link";
import SVG from "react-inlinesvg";
import dynamic from "next/dynamic";
import { Fragment } from "react";
import defaultAuthor from "@/constants/defaultAuthor";
// import { useWindowSize } from "@/hooks/useIsMobile";
import siteInfo from "@/constants/siteInfo";
import { defaultAuthorMap } from "@/utils/langCodeMapper";
import { useRouter } from "next/router";
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
// const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));

const Card = ({ content, isLCP = false, haveH2 = false, isMP = false, isRJ = false, isHR = false, isUP = false, isBH = false, isCGH = false, isUK = false, isBiz = false,isPB=false }) => {
  const defaultAuthorState =
    content?.langcode &&
    content?.langcode in defaultAuthorMap &&
    defaultAuthorMap[content?.langcode];
  const authorLink = content?.author?.[0]?.canonical_url
    ? content?.author?.[0]?.canonical_url
    : defaultAuthorState
      ? defaultAuthorState?.link
      : defaultAuthor.canonical_url;
  const authorTitle =
    (content?.author?.[0]?.title ||
      (content?.author_detail?.[0]?.title !== "mediology"
        ? content?.author_detail?.[0]?.title
        : defaultAuthorState?.name) ||
      defaultAuthorState?.name) ??
    defaultAuthor.title;
  const isPhoto = content?.content_type === "photo_gallery";

  return (
    <div className="flex flex-col overflow-hidden">
      <div className="flex-shrink-0">
        <div className="relative">
          <a
            href={content?.canonical_url ?? ""}
            target={content?.publishtime ? "_blank" : "_self"}
          >
            <div className="w-full aspect-[16/9] overflow-hidden rounded-md">
              <img
                className="w-full h-full object-cover"
                src={`${content?.image_small || content?.thumb_image}?size=360:203`}
                title={content?.image_title}
                alt={
                  content?.image_small_alt_text
                    ? content?.image_small_alt_text
                    : siteInfo?.siteName
                }
                fetchPriority={isLCP ? "high" : "low"}
                loading={isLCP ? "eager" : "lazy"}
              />
            </div>
          </a>

          {content?.content_type === "video" && (
            <a
              href={content?.canonical_url ?? ""}
              target={content?.publishtime ? "_blank" : "_self"}
            >
              <div className="absolute inset-0 flex justify-center items-center">
                <SVG
                  className="w-10 h-10"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/play-media.svg"
                />
              </div>
            </a>
          )}

          {isPhoto && (
            <div className="absolute left-2 w-12 bottom-[8%] md:bottom-[10%] bg-black bg-opacity-60 text-white flex items-center gap-x-2 p-1 rounded">
              <span>
                <SVG
                  className="w-4 h-4"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/gallery.svg"
                />
              </span>
              <p className="text-xl">{content?.photo_count}</p>
            </div>
          )}
        </div>
      </div>

      <div >
        <a
          href={content?.canonical_url ?? ""}
          target={content?.publishtime ? "_blank" : "_self"}
        >
          {haveH2 ? (
            <h2
              className={`my-2 text-md font-bold line-clamp-3 ${isMP ? 'hover:text-[#0C8A70]' : isRJ ? 'hover:text-[#FFA51A]' : isPB ? 'hover:text-[#FFA51A]' : isHR ? 'hover:text-hrDark' : isBH ? 'hover:text-biharDark' : isUP ? 'hover:text-upDark' : isCGH ? 'hover:text-mpDark' : isUK ? "hover:text-ukDark" : isBiz ? "hover:text-bizDark" : 'hover:text-primary'}`}
              dangerouslySetInnerHTML={{
                __html: `${content?.title_short}`,
              }}
            />
          ) : (
            <h3
              className={`text-md my-2 font-bold line-clamp-3 ${isMP ? 'hover:text-[#0C8A70]' : isRJ ? 'hover:text-[#FFA51A]' :isPB ? 'hover:text-[#FFA51A]' : isHR ? 'hover:text-hrDark' : isBH ? 'hover:text-biharDark' : isUP ? 'hover:text-upDark' : isCGH ? 'hover:text-mpDark' : isUK ? "hover:text-ukDark" : isBiz ? "hover:text-bizDark": 'hover:text-primary'}`}
              dangerouslySetInnerHTML={{
                __html: `${content?.title_short}`,
              }}
            />
          )}
        </a>
        <p className="flex items-center text-xs text-gray-500 font-extralight mt-1 mb:text-sm xs:text-sm">
          <img
            className="inline-block mr-1 w-4 h-4"
            alt="read video icon"
            loading="lazy"
            src={
              content?.content_type === "video"
                ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/watchType.svg"
                : "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/readType.svg"
            }
            width="16"
            height="16"
          />
          <time className="mr-1" dateTime={content?.datetime_published || content?.publishtime}>
            {dayjs(content?.datetime_published || content?.publishtime).format(
              "MMM DD YYYY"
            )}
          </time>{" "}
           · By{" "}
          <a
            href={authorLink}
            target={content?.publishtime ? "_blank" : "_self"}
            className={haveH2 ? "inline-block" : ""}
          >
            {haveH2 ? (
              <h3 className={`ml-1 ${isMP ? 'text-[#0C8A70]' : isRJ ? 'text-[#FFA51A]' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isCGH ? 'text-mpDark' : isUK ? "text-ukDark"  : isBiz ? "text-bizDark": isPB ? "text-pbDark" : 'text-primary'}`}>{authorTitle}</h3>
            ) : (
              <span className={`ml-1 ${isMP ? 'text-[#0C8A70]' : isRJ ? 'text-[#FFA51A]' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isCGH ? 'text-mpDark' : isUK ? "text-ukDark" : isBiz ? "text-bizDark" : isPB ? "text-pbDark" :  'text-primary'}`}>{authorTitle}</span>
            )}
          </a>
        </p>
      </div>
    </div>
  );
};

const NewsGrid = ({
  title,
  icon = "",
  newsListData = null,
  isLCP = false,
  showAds = true,
  haveH1 = false, scrolled = false
}) => {
  // const size = useWindowSize();
  const router = useRouter();
  const currentPath = router?.asPath;
  const isMP = currentPath.includes("madhya-pradesh") || title?.includes("मध्य प्रदेश");
  const isRJ = currentPath.includes("rajasthan") || title?.includes("राजस्थान");
  const isHR = currentPath.includes("haryana") || title?.includes("हरियाणा");
  const isBH = currentPath.includes("bihar") || title?.includes("बिहार");
  const isUP = currentPath.includes("uttar-pradesh") || title?.includes("उत्तर प्रदेश");
  const isCGH = currentPath.includes("chhattisgarh") || title?.includes("छत्तीसगढ़");
  const isUK = currentPath.includes("uttarakhand") || title?.includes("उत्तराखंड");
  const isBiz = currentPath.includes("business") || title?.includes("बिजनेस");
  const isPB= currentPath.includes("punjab") || title?.includes("पंजाब");
  return (
    <div className="my-2">
      <div className="flex my-2 items-center">
        {icon && (
          <SVG
            className={`${isMP ? 'text-[#0C8A70]' : isRJ ? 'text-[#FFA51A]' : isPB ? 'text-pbDark' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' : isUP ? 'text-upDark' : isCGH ? 'text-mpDark'
               : isUK ? "text-ukDark"  : isBiz ? "text-bizDark": 'text-primary'} font-bold text-2xl w-7 h-7 inline mr-2 min-w-[29px]`}
            src={icon}
          />
        )}
        <div className={`${isMP ? 'text-[#0C8A70]' : isRJ ? 'text-[#FFA51A]' : isPB ? 'text-pbDark' : isHR ? 'text-hrDark' : isBH ? 'text-biharDark' 
          : isUP ? 'text-upDark' : isCGH ? 'text-mpDark' : isUK ? "text-ukDark" : isBiz ? "text-bizDark" : 'text-primary'} 
          font-bold text-xl mb:font-extrabold sm:font-extrabold xs:font-extrabold`}>
          {haveH1 ? <h1>{title ?? "न्यूज़"}</h1> : <h2>{title ?? "न्यूज़"}</h2>}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2">
        {newsListData?.length > 0 && newsListData?.map((content, index) => (
          <Fragment key={index}>
            <Card
              content={content}
              isLCP={index === 0 ? isLCP : false}
              haveH2={false}
              isMP={isMP}
              isRJ={isRJ}
              isHR={isHR}
              isBH={isBH} isUP={isUP}
              isCGH={isCGH}
              isUK={isUK}
              isBiz={isBiz}
              isPB={isPB}
            />

            {/* {index === 2 && (
              <div className="md:col-span-3 lg:col-span-3">
                {showAds && <VDOAdSlot />}
              </div>
            )} */}
            {index === 8 && showAds && scrolled && (
              <div className="md:col-span-3 lg:col-span-3">
                <AdSlot728x90
                  divId="div-gpt-ad-1707804176041-2"
                  minWidth="720px"
                  minHeight="90px"
                />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default NewsGrid;
